<script>
import Card from "./Card";

export default {
  components: {
    Card
  }
};
</script>

<template>
  <Card
    header="Limpezas na medida"
    text="Agende de forma fácil e rápida, com a duração que você precisar, inclusive para o mesmo dia."
    imagePath="/static/dashboard/on-demand.svg"
  />
</template>



// WEBPACK FOOTER //
// src/components/Dashboard/components/InfoCards/cards/OnDemand.vue